<template>
 <div class="trip-clubbing">
  <div class="trip-clubbing-content">
   <div class="trip-clubbing-filter">
    <v-row>
     <v-col cols="2">
      <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" max-width="630px" min-width="630px" v-model="dateMenu">
       <template v-slot:activator="{ on }">
        <v-text-field dense hide-details v-model="dateText" v-on="on"></v-text-field>
       </template>
       <div class="v-date-time-widget-container">
        <h3 class="text-xs-center">Select Date and Time</h3>
        <v-layout row wrap>
         <v-flex xs12 sm6>
          <!-- :min="convertDate(data.pickupdate)" -->
          <!-- <v-date-picker :value="formattedDates" color="black" width="300" @input="updatePickUpDate($event, index)"></v-date-picker> -->
          <v-date-picker color="black" width="300" v-model="selectedDate"></v-date-picker>
         </v-flex>
         <v-flex xs12 sm6>
          <!-- :min="convertTime(data.pickupdate)" -->
          <v-time-picker v-model="selectedTime" color="black" width="300" format="24hr"></v-time-picker>
         </v-flex>
         <v-flex xs12 class="text-xs-center calendar-footer">
          <v-btn small @click="cancelCalendar" dark>Cancel</v-btn>
          <v-btn small @click="submitDate" dark>Ok</v-btn>
         </v-flex>
        </v-layout>
       </div>
      </v-menu>
      <!-- <v-autocomplete placeholder="Reporting Time" dense hide-details> </v-autocomplete> -->
     </v-col>
     <v-col cols="2">
      <v-autocomplete dense hide-details placeholder="Select Trip Type" :items="tripTypes" item-text="name" item-value="id" v-model="selectedTripType"> </v-autocomplete>
     </v-col>
     <v-col cols="2">
      <v-text-field
       dense
       hide-details
       placeholder="Buffer Time"
       v-model.number="bufferTime"
       type="number"
       suffix="in minutes(max 60)"
       :hide-spin-buttons="true"
       max="60"
       step="1"
       @change="enforceLimits"
      >
      </v-text-field>
     </v-col>
     <v-col cols="1">
      <v-btn color="#c83e18" text><i class="fas fa-redo"></i></v-btn>
     </v-col>
     <v-col cols="3">
      <div class="alert-block"><i class="fas fa-exclamation"></i> Select Date & Time & Trip Type to club Trips</div>
     </v-col>
     <!-- <v-alert text color="info" dense>Select Pickuptime & Trip Type</v-alert> -->
    </v-row>
   </div>
   <div class="trip-clubbing-dashboard">
    <div class="trip-assign-list">
     <div class="assign-filter">
      <v-text-field placeholder="Vehicle Number" dense hide-details v-model="vehicleNo"> </v-text-field>
      <v-btn color="#DB9304" text><i class="fas fa-redo"></i></v-btn>
     </div>
     <!-- @change="checkMove($event, index)" -->
     <div v-if="clubbingTrips.length === 0">
      <draggable v-model="assignedTrips" group="dragItem" :options="{ disabled: true }" class="assign-list">
       <div class="assign-list-block" v-for="(assign, index) in assignedTrips" :key="index">
        <div class="header-block">
         <strong>#{{ assign.id }}</strong>
         <strong v-if="assign.vehicleNo">{{ assign.vehicleNo }}</strong>
        </div>
        <div class="content-list" v-for="(employee, employeeIndex) in assign.employees" :key="employeeIndex">
         <div class="details-block">
          <strong>{{ employee.name }}</strong>
          <span class="mobile-block"><i class="fas fa-phone-alt"></i> {{ employee.mobile }}</span>
         </div>
         <span>{{ employee.address }}</span>
         <strong>Reporting Time : {{ formatDateAndTime(employee.reportingTime) }}</strong>
        </div>
       </div>
      </draggable>
     </div>
     <!-- @change="checkMove($event, index)" -->
     <div v-else>
      <draggable v-model="clubbingTrips" group="dragItem" :options="{ disabled: false }" class="assign-list">
       <div class="assign-list-block" v-for="(assign, index) in clubbingTrips" :key="index" :class="{ 'color-change': assign.tobeassgined }">
        <div class="header-block">
         <strong>#{{ assign.id }}</strong>
         <strong>{{ assign.vehicleNo }}</strong>
        </div>
        <div class="content-list" v-for="(employee, employeeIndex) in assign.employees" :key="employeeIndex">
         <div class="details-block">
          <strong>{{ employee.name }}</strong>
          <span class="mobile-block"><i class="fas fa-phone-alt"></i> {{ employee.mobile }}</span>
         </div>
         <span>{{ employee.address }}</span>
         <strong>Reporting Time : {{ formatDateAndTime(employee.reportingTime) }}</strong>
        </div>
       </div>
      </draggable>
     </div>
     <div class="club-button" v-if="clubbingTrips.length > 1">
      <button @click="clubTrip">Club Trip</button>
     </div>
    </div>

    <div class="trip-assigning-list">
     <div class="assign-header">
      <span>Trip ID</span>
      <span>User Details</span>
      <span class="content-block">Locations</span>
      <span>Reporting Time</span>
     </div>
     <!-- @change="checkMove($event, index)" -->
     <draggable v-model="tobeAsssignedTrips" group="dragItem" :options="dragOption" class="tobe-assigned-list">
      <div class="tobe-assigned-list-block" v-for="(trip, index) in tobeAsssignedTrips" :key="index">
       <span>#{{ trip.id }}</span>
       <span v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex">
        {{ employee.name }}
       </span>
       <span v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex" class="content-block">
        {{ employee.address }}
       </span>
       <span>
        {{ formatDateAndTime(trip.employees[0].reportingTime) }}
       </span>
      </div>
     </draggable>

     <!-- <v-data-table :items="items" :headers="headers" item-value="id" height="calc(100vh - 220px)" hide-default-footer class="sticky-header">
      <template v-slot:body="{ items, headers }">
       <tbody>yh
        <draggable v-model="tobeAsssignedTrips" group="dragItem" @change="checkMove($event, index)" :options="dragOption">
         <tr :class="{ deleted: driver.trashStatus === 1 }" v-for="(driver, index) in tobeAsssignedTrips" :key="index">
          <td>#{{ driver.id }}</td>
          <td v-for="(employee, employeeIndex) in driver.employees" :key="employeeIndex">
           {{ employee.name }}
          </td>
          <td v-for="(employee, employeeIndex) in driver.employees" :key="employeeIndex">
           {{ employee.address }}
          </td>
          <td>
           {{ formatDateAndTime(driver.employees[0].reportingTime) }}
          </td>
         </tr>
        </draggable>
       </tbody>
      </template>
     </v-data-table> -->
    </div>
   </div>
  </div>
  <Loading v-if="loading"></Loading>
  <Confirm ref="confirm"></Confirm>
 </div>
</template>

<script>
import axios from "@/axios/axios-global";
import moment from "moment";
import draggable from "vuedraggable/src/vuedraggable";
import Confirm from "@/components/common/Confirm";
import Loading from "@/components/common/Loading";
export default {
 name: "TripClubbing",
 components: { draggable, Confirm, Loading },
 data() {
  return {
   selectedDate: "",
   selectedTime: "",
   selectedTripType: 0,
   bufferTime: "",
   dateMenu: false,
   tripTypes: [
    { id: 1, name: "PickUp" },
    { id: 2, name: "DropOff" },
   ],

   vehicleNo: "",

   assignedTrips: [],
   tobeAsssignedTrips: [],
   clubbingTrips: [],

   headers: [
    { text: "Trip Id", value: "tripId" },
    { text: "User Details", value: "user", sortable: false },
    { text: "Locations", value: "location", sortable: false },
    { text: "Reporting Time", value: "reportingTime", sortable: false },
   ],

   loading: false,

   dragOption: {
    disabled: true,
   },
  };
 },
 mounted() {
  //   this.getAssignedTrips();
  //   this.getTobeAsssignedTrips();
 },
 watch: {
  vehicleNo() {
   this.clubbingTrips = this.assignedTrips.filter((data) => {
    return data.vehicleNo.toLowerCase() === this.vehicleNo.toLowerCase();
   });
   if (this.clubbingTrips.length === 0) this.dragOption.disabled = true;
   else this.dragOption.disabled = false;
  },
  selectedTripType() {
   this.getAssignedTrips();
   this.getTobeAsssignedTrips();
  },
 },
 methods: {
  async getAssignedTrips() {
   const dateTime = `${this.selectedDate} ${this.selectedTime}`;
   const payload = {
    reportingTime: moment(dateTime, "YYYY-MM-DD HH:mm").valueOf(),
    isClubbed: true,
    serviceType: this.selectedTripType,
   };
   const response = await axios.post("trip/toBeClubbed/list", payload);
   if (response.status === 200) {
    this.assignedTrips = response.data;
   }
  },
  async getTobeAsssignedTrips() {
   this.loading = true;
   const dateTime = `${this.selectedDate} ${this.selectedTime}`;
   console.log(dateTime);
   const payload = {
    reportingTime: moment(dateTime, "YYYY-MM-DD HH:mm").valueOf(),
    isClubbed: false,
    serviceType: this.selectedTripType,
   };
   const response = await axios.post("trip/toBeClubbed/list", payload);
   this.loading = false;
   if (response.status === 200) {
    this.tobeAsssignedTrips = response.data;
    this.tobeAsssignedTrips.map((data) => {
     data["tobeassgined"] = true;
    });
   }
  },
  formatDateAndTime(date) {
   console.log(date, "date");
   return moment(date).format("DD-MM-YYYY hh:mm A");
  },
  async clubTrip() {
   let confirmTitle = "Confirm Clubbing";
   let confirmText = "Please confirm to Club the trips";
   if (await this.$refs.confirm.open(confirmTitle, confirmText)) {
    try {
     let clubTo = 0;
     let clubFrom = [];
     this.clubbingTrips.map((data) => {
      if (!data.tobeassgined) clubTo = data.tripId;
      if (data.tobeassgined) clubFrom.push(data.tripId);
     });
     const payload = {
      clubTo: clubTo,
      clubFrom: clubFrom,
     };
     const response = await axios.post("trip/clubbing", payload);
     console.log(response);
     if (response.status === 200) {
      this.$toasted.show(response.data, {
       position: "bottom-center",
       duration: 5000,
      });
      this.vehicleNo = "";
      this.getAssignedTrips();
      this.getTobeAsssignedTrips();
      this.clubbingTrips = [];
     } else {
      this.$toasted.show(response.data, {
       position: "bottom-center",
       duration: 5000,
      });
     }
    } catch (error) {
     console.log("error", error);
    }
   }
  },

  enforceLimits() {
   console.log(this.bufferTime);
   if (this.bufferTime > 60) this.bufferTime = 60;
  },
  cancelCalendar() {
   this.dateMenu = false;
   this.selectedDate = "";
   this.selectedTime = "";
  },
  async submitDate() {
   this.dateMenu = false;
   if (this.selectedDate && this.selectedTime) {
    await this.getAssignedTrips();
    await this.getTobeAsssignedTrips();
   }
  },
 },
 computed: {
  dateText() {
   if (this.selectedDate && this.selectedTime) {
    return `${this.selectedDate} ${this.selectedTime}`;
   } else {
    return "Select Date & Time";
   }
  },
 },
};
</script>

<style lang="scss" scoped>
.trip-clubbing {
 padding: 10px 20px;
 .trip-clubbing-filter {
  background: white;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(25, 32, 36, 0.16), 0 -1px 4px rgba(25, 32, 36, 0.04);
  align-items: center;
  input {
   width: 200px;
  }
  ::v-deep .v-text-field__suffix {
   font-size: 12px;
  }
  .alert-block {
   //  background: rgba(0, 123, 255, 0.275);
   padding: 10px;
   font-size: 13px;
   color: #1b95d1;
   border-radius: 3px;
   font-weight: bold;
  }
 }
 .trip-clubbing-dashboard {
  display: flex;
  gap: 15px;
  margin-top: 15px;
  .trip-assign-list {
   background: white;
   box-shadow: 0 3px 6px rgba(25, 32, 36, 0.16), 0 -1px 4px rgba(25, 32, 36, 0.04);
   border-radius: 5px;
   width: 30%;
   height: calc(100vh - 180px);
   overflow-y: auto;
   .assign-filter {
    display: flex;
    gap: 5px;
    position: sticky;
    top: 0;
    background: white;
    padding: 20px 20px 0 20px;
   }
   .assign-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
    padding: 0 20px 0 20px;
    .assign-list-block {
     border: 1px solid rgb(215, 215, 215);
     padding: 10px;
     border-radius: 5px;
     padding: 15px;
     display: flex;
     flex-direction: column;
     gap: 10px;
     .header-block {
      display: flex;
      justify-content: space-between;
      gap: 10px;

      strong {
       color: grey;
      }
     }
     .content-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-bottom: 1px solid rgb(229, 229, 229);
      padding: 5px 0;
      font-size: 13px;
      &:last-child {
       border-bottom: none;
      }
      .details-block {
       display: flex;
       gap: 10px;
       text-transform: uppercase;
       .mobile-block {
        padding-left: 8px;
        border-left: 1px solid rgb(221, 221, 221);
        .fas {
         color: #2f93d6;
         font-size: 12px;
        }
       }
      }

      strong {
       color: rgba(15, 79, 135, 0.498);
      }
     }
    }

    .color-change {
     background: #1bc0ad1b;
    }
   }

   .club-button {
    position: sticky;
    bottom: 0;
    padding: 10px 20px;
    button {
     background: #1bc0ae;
     padding: 8px;
     text-transform: uppercase;
     width: 100%;
     border-radius: 5px;
     color: white;
     font-weight: bold;
    }
   }
  }

  .trip-assigning-list {
   padding: 20px;
   background: white;
   box-shadow: 0 3px 6px rgba(25, 32, 36, 0.16), 0 -1px 4px rgba(25, 32, 36, 0.04);
   border-radius: 5px;
   width: 70%;
   height: calc(100vh - 180px);
   overflow-y: auto;
   .assign-header,
   .tobe-assigned-list-block {
    display: flex;
    padding: 8px;
    border-bottom: 1px solid #e3e3e3;
    align-items: center;
    gap: 10px;
    span {
     width: 16%;
     font-size: 12px;
     color: grey;
    }
    .content-block {
     flex: 1;
    }
   }
   .tobe-assigned-list {
    display: flex;
    flex-direction: column;
    .tobe-assigned-list-block {
     padding: 13px;
     cursor: pointer;
     span {
      color: #000;
     }
    }
   }
  }
 }
}

.v-date-time-widget-container .flex {
 display: flex;
 flex-direction: column;
 padding: 0 5px;
 justify-content: space-between;
}

.v-date-time-widget-container .flex.text-xs-center {
 flex-direction: row;
 justify-content: flex-end;
 padding: 0;
}

.v-date-time-widget-container {
 background: white;
 padding: 15px;
}

.v-date-time-widget-container {
 background: white;
 padding: 15px;
}

.row {
 margin-top: 0;
}
.v-date-time-widget-container h3 {
 font-weight: 800;
 font-size: 1.1rem;
 //  color: #db670f;
 text-align: center;
 padding: 5px 0;
}
.calendar-footer {
 padding: 5px !important;
}
.v-date-time-widget-container .calendar-footer .v-btn {
 margin-left: 10px;
}
</style>
